import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

const deadliftAntropometryApi = createApi({
  reducerPath: 'deadlift_antropometry',
  tagTypes: ['DeadliftAntropometry'],
  baseQuery,
  endpoints(builder) {
    return {
      fetchDeadliftAntropometrys: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'DeadliftAntropometry', id: 'LIST' },
                ...result.map((r) => ({ type: 'DeadliftAntropometry', id: r.id })),
              ]
            : [{ type: 'DeadliftAntropometry', id: 'LIST' }],
        query: () => ({
          url: `?resource=deadlift_antropometry&order=created_at.asc`,
          method: 'GET',
        }),
      }),

      fetchDeadliftAntropometry: builder.query({
        providesTags: (result, error, arg) => [{ type: 'DeadliftAntropometry', id: arg }],
        query: (id) => ({
          url: `?resource=deadlift_antropometry&id=eq.${id}`,
          method: 'GET',
        }),
      }),

      fetchDeadliftAntropometryByAthleteId: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'DeadliftAntropometry', id: 'LIST' },
                ...result.map((r) => ({ type: 'DeadliftAntropometry', id: r.id })),
              ]
            : [{ type: 'DeadliftAntropometry', id: 'LIST' }],
        query: (athleteId) => ({
          url: `?resource=deadlift_antropometry&athlete=eq.${athleteId}&order=created_at.desc`,
          method: 'GET',
        }),
      }),

      createDeadliftAntropometry: builder.mutation({
        invalidatesTags: [{ type: 'DeadliftAntropometry', id: 'LIST' }],
        query: (data) => ({
          url: `?resource=deadlift_antropometry`,
          method: 'POST',
          body: data,
        }),
      }),

      updateDeadliftAntropometry: builder.mutation({
        invalidatesTags: (result, error, { id: deadlift_antropometryId }) => [
          { type: 'DeadliftAntropometry', id: deadlift_antropometryId },
          { type: 'DeadliftAntropometry', id: 'LIST' },
        ],
        query: ({ id: deadlift_antropometryId, submitData }) => ({
          url: `?resource=deadlift_antropometry&id=eq.${deadlift_antropometryId}`,
          method: 'PATCH',
          body: submitData,
        }),
      }),
    };
  },
});

export const {
  useFetchDeadliftAntropometrysQuery,
  useCreateDeadliftAntropometryMutation,
  useUpdateDeadliftAntropometryMutation,
  useFetchDeadliftAntropometryQuery,
  useFetchDeadliftAntropometryByAthleteIdQuery,
} = deadliftAntropometryApi;

export { deadliftAntropometryApi };
